import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { theme } from './theme.js';

// Globale basisstijl injecteren (reset + huisstijl).
const style = document.createElement('style');
style.textContent = `
  html, body { margin: 0; padding: 0; }
  body {
    background: ${theme.color.bg};
    font-family: ${theme.font.body};
    color: ${theme.color.text};
    -webkit-font-smoothing: antialiased;
  }
  * { box-sizing: border-box; }
  a { color: ${theme.color.link}; text-decoration: none; }
  a:hover { text-decoration: underline; }
  ::placeholder { color: ${theme.color.subtle}; }
  @keyframes swg-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
`;
document.head.appendChild(style);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root-element ontbreekt.');
}

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
